import React from 'react';

const HomeHeatTypeFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.25 16.3333C18.25 17.8632 16.6967 19.25 15 19.25C13.3033 19.25 11.75 17.8632 11.75 16.3333C11.75 15.1582 12.233 13.9278 12.8991 12.8039C13.5593 11.6898 14.3597 10.7466 14.9047 10.1619C14.938 10.1262 14.9721 10.116 15 10.116C15.0279 10.116 15.062 10.1262 15.0953 10.1619C15.6403 10.7466 16.4407 11.6898 17.1009 12.8039C17.767 13.9278 18.25 15.1582 18.25 16.3333Z"
      strokeWidth="1.5"
    />
    <path
      d="M16.25 17.9C16.25 18.6805 15.6563 19.25 15 19.25C14.3437 19.25 13.75 18.6805 13.75 17.9C13.75 17.5235 13.9548 16.9447 14.2995 16.4357C14.4655 16.1907 14.6395 15.999 14.793 15.8768C14.9106 15.7832 14.9796 15.7585 15 15.7521C15.0204 15.7585 15.0894 15.7832 15.207 15.8768C15.3605 15.999 15.5345 16.1907 15.7005 16.4357C16.0452 16.9447 16.25 17.5235 16.25 17.9Z"
      strokeWidth="1.5"
    />
    <path
      d="M2.50098 8.91404L9.11352 3.24603C9.62419 2.80829 10.3778 2.80829 10.8884 3.24603L17.501 8.91404"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.4296 8.01051V3.18182C16.4296 3.00099 16.3578 2.82756 16.2299 2.6997C16.102 2.57183 15.9286 2.5 15.7478 2.5H13.7023C13.3258 2.5 13.0205 2.80526 13.0205 3.18182V5.08833"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.95508 16.668V12.3498C7.95508 11.9732 8.26047 11.668 8.63719 11.668H10.0014"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3.57211 8.01172V16.6679" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.16764 16.6668H2.50098" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default HomeHeatTypeFilterIcon;
